import React from "react";
import { motion } from "framer-motion";
import "./Experience.css";

export const experiences = [
  {
    date: "Sep 2024 — Present",
    role: "Software Development Engineer, 1",
    promotedFrom: "Software Development Engineer, Associate · Mar 2026",
    company: "Capital Group",
    location: "Irvine, CA",
    description:
      "Own and maintain production services spanning full-stack applications, streaming pipelines, and cloud infrastructure. Day-to-day work covers backend services in C# / .NET Core and Python / FastAPI, React frontends, Kafka producers and consumers, and the Terraform modules + GitHub Actions pipelines.",
    tags: [
      "C#",
      ".NET Core",
      "FastAPI",
      "Python",
      "React",
      "Kafka",
      "Terraform",
      "AWS",
    ],
  },
  {
    date: "Oct 2023 — Jul 2024",
    role: "Undergraduate Research Assistant",
    company: "California State University, Fullerton",
    location: "Fullerton, CA",
    description:
      "Built TinyTeller AI, an adaptive storytelling system (React, Django, OpenAI API). Designed parsing algorithms that convert free-form GPT-4 responses into structured decision trees, and prompt-engineered to reduce hallucinated narrative branches.",
    tags: ["React", "Django", "OpenAI API", "Prompt Engineering"],
  },
];

const Experience = () => {
  return (
    <section id="experience">
      <motion.div
        className="section-heading"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="eyebrow">02 — Experience</span>
        <h2 className="display">
          Building <em>under pressure.</em>
        </h2>
      </motion.div>

      <div className="exp-list">
        {experiences.map((exp, index) => (
          <motion.article
            key={index}
            className="exp-row"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.6,
              delay: index * 0.06,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            <div className="exp-aside">
              <span className="exp-num">
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="exp-date">{exp.date}</span>
              <span className="exp-location">{exp.location}</span>
            </div>

            <div className="exp-main">
              <h3 className="exp-role">{exp.role}</h3>
              {exp.promotedFrom && (
                <p className="exp-prior-role">
                  <span className="exp-prior-arrow" aria-hidden="true">
                    ↑
                  </span>
                  {" promoted from "}
                  {exp.promotedFrom}
                </p>
              )}
              <p className="exp-company">
                <span className="exp-company-name">{exp.company}</span>
              </p>
              <p className="exp-description">{exp.description}</p>
              <div className="exp-tags">
                {exp.tags.map((tag) => (
                  <span key={tag} className="mono-tag">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
};

export default Experience;
